import { getUpgradePageUrl } from 'self-service-api/core/utilities/links';
export const openUpgradePageInNewTab = upgradeKey => {
  const redirectUrl = getUpgradePageUrl(upgradeKey);
  window.open(redirectUrl, '_blank');
};